/**
 * Scroll lock for modals.
 *
 * The document itself never scrolls (html/body are overflow:hidden);
 * all scrolling happens inside #app. Unlike body, an inner scroll
 * container keeps its scrollTop while overflow is hidden, so locking
 * is a single style toggle — no position:fixed / scrollY juggling.
 */

let lockCount = 0;

function getScroller(): HTMLElement {
  return document.getElementById('app') ?? document.documentElement;
}

export function lockScroll(): void {
  lockCount += 1;
  if (lockCount === 1) {
    getScroller().style.overflowY = 'hidden';
  }
}

export function unlockScroll(): void {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    getScroller().style.overflowY = '';
  }
}
